import axios from '../../../../untils/request.js'
// 获取企业已发布的职位列表
export async function getPublishPositionList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getPublishPositionList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//   获取企业已发布的二类职位编码列表
export async function getPublishPositionCodes (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getPublishPositionCodes',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//   获取已发布职位的搜索下拉列表
export async function positionSearchList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/positionSearchList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
 

//   获取职位类别选择  info->sys
export async function getPositionSelect (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/sys/getPositionSelect',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 发布新职位
export async function publishPosition (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/publishPosition',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取公司地址
export async function getCompanyAddress (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getCompanyAddress',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取自定义技能列表
export async function getCustomizePositionSkillList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getCustomizePositionSkillList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 添加自定义技能
export async function addCustomizePositionSkill (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/addCustomizePositionSkill',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 删除自定义技能
export async function delCustomizePositionSkill (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/delCustomizePositionSkill',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 关闭职位
export async function closePosition (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/closePosition',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 开启职位
export async function openPosition (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/openPosition',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 职位放到回收站或从回收站恢复
export async function trashOrRestore (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/trashOrRestore',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 删除职位
export async function delPosition (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/delPosition',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 获取企业职位详情
export async function getCompanyPositionDetail (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getCompanyPositionDetail',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 精英推荐
export async function recommendEliteByConditions (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/recommendEliteByConditions',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 查看精英简历
export async function viewEliteResume (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/viewEliteResume',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 设置精英为不合适
export async function addInappropriateElite (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/addInappropriateElite',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 设置精英为收藏
export async function addCollectElite (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/addCollectElite',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 取消精英收藏
export async function cancelCollectElite (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/cancelCollectElite',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 精英推荐查看用户信用评价
export async function lookUserCreditEvaluationByUserId (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/user/lookUserCreditEvaluationByUserId',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取企业管理员已沟通的精英列表
export async function communicateList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/communicateList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取不合适精英列表
export async function inappropriateList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/inappropriateList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 批量取消不合适
export async function cancelInappropriateElite (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/cancelInappropriateElite',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取企业已约面的精英列表
export async function interviewList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/interviewList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 精英管理列表
export async function paidList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/paidList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 精英管理列表
export async function collectList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminElite/collectList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 面试管理列表
export async function adminInterviewManage (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminInterviewManage',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 面试管理-面试状态统计
export async function interviewManageCount (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/interviewManageCount',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 面试日程列表
export async function adminInterviewSchedule (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/adminInterviewSchedule',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 更改面试时间，面试地点
export async function changeInterviewTime (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/changeInterviewTime',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 举报接口：用户或企业 举报用户,企业，职位
export async function report (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/user/report',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 招聘者申请精英联系方式
export async function contactApply (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/contactApply',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 企业管理员同意给予联系方式
export async function agreeProvidePersonContactInfo (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/agreeProvidePersonContactInfo',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 企业被索要联系方式列表
export async function companyGetPersonApplyRecord (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/companyGetPersonApplyRecord',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 企业管理员拒绝给予联系方式
export async function rejectProvidePersonContactInfo (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/rejectProvidePersonContactInfo',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 企业索要联系方式列表
export async function getContactApplyRecordForCompany (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/getContactApplyRecordForCompany',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取招聘数据
export async function getRecruitmentData (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getRecruitmentData',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 根据条件获取数据列表
export async function listRecruitment (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/listRecruitment',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取已发布职位信息列表
export async function getPublishPositionInfoList (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getPublishPositionInfoList',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 获取招聘趋势图
export async function getRecruitmentTrendChart (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/company/getRecruitmentTrendChart',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}